import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import StepperCustom from "../../../../components/step/Stepper";
import { icons } from "../../../../assets/icons/icons";
import CardInfoComponent from "../components/CardInfo";
import { colors } from "../../../../constants/colors";
import { MenuItem, Typography } from "@mui/material";
import InputTextField from "../../../../components/input/inputTextField";
import { SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import InputNewRangePicker from "../../../../components/input/inputRankPicker";
import moment from "moment";
import ListConsultationRequest from "../components/ListConsultationRequest";
import FilterSelect from "../../../../components/select/filterSelect";
import ListAdvisoryRequest from "../components/ListAdvisoryRequest";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { advisorApi } from "../../../../api/advisor/advisor.api";
import ListDocuments from "../../../student/choose-advisor/components/ListDocuments";
import {
  allStatusAdvisorRequestUtil,
  allStatusConsultRequestUtil,
  handleColorStatusConsultRequestUtil,
} from "../../../../utils/statusRequest";
import { useDispatch, useSelector } from "react-redux";
import { advisorTypeApi } from "../../../../api/advisor-type/advisor-type.api";
import DropdownButton from "../../../../components/button/DropdownButton";
import { getFileExtension } from "../../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import { advisorRequestApi } from "../../../../api/advisor-request/advisor-request.api";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../components/alert/swal";

const ManageAdvisorRequest = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [tabStep, setTebStep] = useState(0);

  const [inputValueSearch, setInputValueSearch] = useState({
    keyword: "",
    consultation_type: "",
    status: "",
  });

  const [inputValue, setInputValue] = useState<any>({
    advisor_id: 0,
    adv_fullname: "",
    adv_employee_id: "",

    adv_employee_no: "",
    adv_position: "",
    adv_department: "",
    start_date: new Date(),
    course: [],
    evaluation_form: 0,
    maximum_student: 0,
    count_advisor_req: 0,
    count_req_all: 0,
  });

  const [dataAdvisorRequest, setDataAdvisorRequest] = useState<any>([]);

  const [search, setSearch] = useState<string>("");

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const { profile } = useSelector((state: any) => state.profile);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);

  // approve
  const [selectedDataApprove, setSelectedDataApprove] = useState<any[]>([]);

  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const fetchGetAdvisorRequestByUserLogin = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sdate: startDate,
      edate: endDate,
      status: inputValueSearch.status,
    };

    if (search) query = { ...query, search: search };

    await advisorApi.getAdvisorRequestByUserLogin(query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataAdvisorRequest(data.data?.advisor_request?.items ?? []);
        setInputValue({
          advisor_id: data.data.id_advisor,
          adv_fullname: data.data.first_name + "" + data.data.last_name,
          adv_employee_id: data.data.id_employee,

          adv_employee_no: data.data.employee_no,
          adv_position: data.data,
          adv_department: data.data.id_department,
          start_date: data.data.advisor_start_date,
          course: data.data.faculty_names,
          evaluation_form: data.data,
          maximum_student: data.data.number_students,
          count_advisor_req: data.data.count_req,
          count_req_all: data.data.count_req_all,
        });
        setTotalItems(data.data?.advisor_request?.meta?.totalItems ?? 0);
      } else {
        setDataAdvisorRequest([]);
        setInputValue({
          adv_fullname: "",
          adv_employee_id: "",
          adv_employee_no: "",
          adv_position: "",
          adv_department: "",
          start_date: new Date(),
          course: [],
          evaluation_form: 0,
          maximum_student: 0,
          count_advisor_req: 0,
          count_req_all: 0,
        });
      }
    })
  };

  useEffect(() => {
    if (tabStep === 0) {
      fetchGetAdvisorRequestByUserLogin();
    }
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    inputValueSearch,
    tabStep,
    startDate,
    endDate,
  ]);

  const getAdvisorType = async () => {
    const res = await advisorTypeApi.getAllAdvisorType();

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
  }, []);

  const allStep = [
    {
      name: "ข้อมูลอาจารย์ที่ปรึกษาวิทยานิพนธ์",
      isAccept: false,
      icon: (
        <img
          src={icons.user_square}
          alt="book"
          style={{
            cursor: "pointer",
            filter: tabStep === 0 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
    {
      name: "การขอคำปรึกษา",
      isAccept: false,
      icon: (
        <img
          src={icons.sms_edit}
          alt="folder"
          style={{
            cursor: "pointer",
            filter: tabStep === 1 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
    {
      name: "เอกสารประกอบ",
      isAccept: false,
      icon: (
        <img
          src={icons.folder_3}
          alt="folder"
          style={{
            cursor: "pointer",
            filter: tabStep === 2 ? "brightness(0) invert(1)" : "",
          }}
        />
      ),
    },
  ];

  const arrayCardInfo = [
    {
      color: colors.textNormal,
      title: "จำนวนที่รับนักศึกษาได้สูงสุด",
      amount: inputValue.maximum_student
        ? parseInt(inputValue.maximum_student.toString())
        : 0,
      bgColor: colors.placeholder2,
    },
    {
      color: colors.white,
      title: "จำนวนคำร้อง",
      amount: inputValue.count_req_all
        ? parseInt(inputValue.count_req_all.toString())
        : 0,
      bgColor: colors.subPrimary,
    },
    {
      color: colors.white,
      title: "จำนวนนักศึกษาที่รับเป็นที่ปรึกษา",
      amount: inputValue.count_advisor_req
        ? parseInt(inputValue.count_advisor_req.toString())
        : 0,
      bgColor: colors.success3,
    },
  ];

  const handleDownloadFileAdvisorRequest = async (type: string) => {
    dispatch(setLoading());
    let query: any = {
      page: 1,
      limit: 1000000,
      sortBy: sortBy,
      sortType: sortType,
      sdate: startDate,
      edate: endDate,
      status: inputValueSearch.status,
      export_type: type ?? "pdf",
    };

    if (search) query = { ...query, search: search };

    await advisorApi
      .getDownloadAdvisorStudentRequestByIdAndAdvisor(query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          const title = "รายการคำขอให้เป็นที่ปรึกษา";
          const dateString = new Date().getTime();

          const fileName = `${title}-${dateString}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const handleApproveRequest = async (status: string, idApprove: any[]) => {
    if (status && idApprove.length > 0) {
      const title =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์"
          : "ปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์";
      const subTitle =
        status === "อนุมัติ"
          ? "ท่านต้องการตอบรับคำร้องขอให้เป็นที่ปรึกษา ใช่หรือไม่"
          : "ท่านต้องการปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์ ใช่หรือไม่";
      const titleResult =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์"
          : "ปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์";
      const subTitleResult =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษา เรียบร้อยแล้ว"
          : "ปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์ เรียบร้อยแล้ว";
      const errorMessage =
        status === "อนุมัติ"
          ? "ตอบรับคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์ ไม่สำเร็จ"
          : "ปฏิเสธคำร้องขอให้เป็นที่ปรึกษาวิทยานิพนธ์ ไม่สำเร็จ";

      alertActive(title, subTitle, undefined, undefined, async () => {
        try {
          await Promise.all(
            idApprove.map(async (idRequest: any) => {
              await advisorRequestApi.updateStatusAdvisorRequest(
                idRequest,
                status
              );
            })
          );

          alertSuccess(titleResult, subTitleResult, undefined, () => {
            fetchGetAdvisorRequestByUserLogin();
            setSelectedDataApprove([]);
          });
        } catch (error) {
          alertError(errorMessage);
        } finally {
          dispatch(unsetLoading());
        }

        // dispatch(setLoading());
        // await advisorRequestApi
        //   .updateStatusAdvisorRequest(+id, status, "")
        //   .then((res) => {
        //     if (res.status < 300) {
        //       alertSuccess(titleResult, subTitleResult, undefined, () => {
        //         // navigate(routeName.advisor.manageAdvisorRequest);
        //       });
        //     }
        //   })
        //   .catch(() => {
        //     alertError(errorMessage);
        //   })
        //   .finally(() => {
        //     dispatch(unsetLoading());
        //   });
      });
    }
    return;
  };

  return (
    <div>
      <ContentHeading
        title={"ระบบ Advisor"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <StepperCustom
          step={tabStep}
          setStep={setTebStep}
          stepLabel={allStep}
          view={true}
        />
      </section>

      {tabStep === 0 ? (
        <>
          <section
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            {arrayCardInfo.map((item, index) => {
              return (
                <CardInfoComponent
                  key={index + 1}
                  color={item.color}
                  title={item.title}
                  amount={item.amount}
                  bgColor={item.bgColor}
                />
              );
            })}
          </section>
          <section className="w-full mt-4">
            <Typography variant="h6">รายการคำขอให้เป็นที่ปรึกษา</Typography>
          </section>

          <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
            <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
              <InputTextField
                startAdornment={<SearchOutlined />}
                placeholder="ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่"
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  debouncedApiCall({
                    searchItem: e.target.value,
                    setItem: setSearch,
                  })
                }
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <InputNewRangePicker
                value={selectedDateRange}
                onchange={handleRangeDate}
                onClear={handleClearRangeDate}
                allowClear
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <FilterSelect
                value={inputValueSearch.status ?? ""}
                labelId="status-id"
                selectId="status-select-id"
                options={[
                  {
                    id_status: "",
                    status_name: "ทุกสถานะ",
                  },
                  ...allStatusAdvisorRequestUtil.map((item) => ({
                    id_status: item,
                    status_name: item,
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.id_status} key={index + 1}>
                    {list.status_name}
                  </MenuItem>
                ))}

                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValueSearch("status", e.target.value)
                }

              />
            </article>

            <article
              className="w-full col-span-12 lg:col-span-3 md:col-span-4 sm:col-span-12"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <ButtonPrimary
                onClick={() => {
                  handleApproveRequest("อนุมัติ", selectedDataApprove);
                }}
                mode={"done"}
                buttonName={"ตอบรับ"}
                btnProps={{
                  width: "125px",
                  margin: "0 10px 0 10px",
                }}
                disabled={selectedDataApprove.length === 0}
              />

              <ButtonPrimary
                onClick={() => {
                  handleApproveRequest("ไม่อนุมัติ", selectedDataApprove);
                }}
                mode={"cancel"}
                buttonName={"ปฏิเสธ"}
                btnProps={{
                  width: "125px",
                }}
                disabled={selectedDataApprove.length === 0}
              />
            </article>
          </div>

          <section className="w-full mt-4">
            <ListAdvisoryRequest
              data={dataAdvisorRequest}
              page={page}
              setPage={setPage}
              totalItems={totalItems}
              sortBy={sortBy}
              sortType={sortType}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              selectedDataApprove={selectedDataApprove}
              setSelectedDataApprove={setSelectedDataApprove}
            />
          </section>
        </>
      ) : tabStep === 1 ? (
        <>
          <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
            <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
              <InputTextField
                startAdornment={<SearchOutlined />}
                placeholder="ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่"
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  debouncedApiCall({
                    searchItem: e.target.value,
                    setItem: setSearch,
                  })
                }
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
              <InputNewRangePicker
                value={selectedDateRange}
                onchange={handleRangeDate}
                onClear={handleClearRangeDate}
                allowClear
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
              <FilterSelect
                value={inputValueSearch.consultation_type ?? ""}
                labelId="consultation_type-id"
                selectId="consultation_type-select-id"
                placeholder="เลือกเรื่องที่ขอคำปรึกษา"
                options={[
                  {
                    id_type: "",
                    type_name: "ทุกเรื่องที่ขอคำปรึกษา",
                  },
                  ...dataAdvisorType.map((list) => ({
                    id_type: list.id_advisor_type,
                    type_name: list.advisor_type_name,
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.type_name} key={index + 1}>
                    {list.type_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValueSearch("consultation_type", e.target.value)
                }
              />
            </article>

            <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
              <FilterSelect
                value={inputValueSearch.status ?? ""}
                labelId="status-id"
                selectId="status-select-id"
                options={[
                  {
                    id_status: "",
                    status_name: "ทุกสถานะ",
                  },
                  ...allStatusConsultRequestUtil.map((item) => ({
                    id_status: item,
                    status_name: handleColorStatusConsultRequestUtil(
                      item,
                      profile && profile.user_type
                    ),
                  })),
                ].map((list, index) => (
                  <MenuItem value={list.id_status} key={index + 1}>
                    {list.status_name}
                  </MenuItem>
                ))}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeValueSearch("status", e.target.value)
                }
              />
            </article>

            <article
              className="w-full col-span-12 lg:col-span-2 md:col-span-4 sm:col-span-12"
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div>
                <DropdownButton
                  buttonName={"ดาวน์โหลดไฟล์"}
                  menuItems={[
                    {
                      id: 1,
                      name: "pdf",
                      onClick: () => {
                        handleDownloadFileAdvisorRequest("pdf");
                      },
                    },
                    {
                      id: 2,
                      name: "excel",
                      onClick: () => {
                        // if (id) {
                        handleDownloadFileAdvisorRequest("xlsx");
                        // }
                      },
                    },
                  ]}
                  fullWidth={true}
                />
              </div>
            </article>
          </div>

          <section className="w-full mt-4">
            <ListConsultationRequest
              search={search}
              page={page}
              setPage={setPage}
              setTotalItems={setTotalItems}
              totalItems={totalItems}
              sortBy={sortBy}
              sortType={sortType}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              startDate={startDate}
              endDate={endDate}
              inputValueSearch={inputValueSearch}
              tabStep={tabStep}
            />
          </section>
        </>
      ) : tabStep === 2 ? (
        <ListDocuments />
      ) : null}
    </div>
  );
};

export default ManageAdvisorRequest;
